import { useEffect, useState } from "react";

const TARGET_UTC = Date.UTC(2026, 5, 15, 10, 0, 0); // 2026-06-15 06:00 ET == 2026-06-15 10:00 UTC (EDT, UTC-4)

function diff(target) {
  const now = Date.now();
  const ms = Math.max(0, target - now);
  const days = Math.floor(ms / 86400000);
  const hours = Math.floor((ms % 86400000) / 3600000);
  const minutes = Math.floor((ms % 3600000) / 60000);
  const seconds = Math.floor((ms % 60000) / 1000);
  return { ms, days, hours, minutes, seconds };
}

export default function Countdown() {
  const [t, setT] = useState(() => diff(TARGET_UTC));

  useEffect(() => {
    const id = setInterval(() => setT(diff(TARGET_UTC)), 1000);
    return () => clearInterval(id);
  }, []);

  const isLive = t.ms === 0;

  const cells = [
    { label: "Days", value: t.days },
    { label: "Hours", value: t.hours },
    { label: "Minutes", value: t.minutes },
    { label: "Seconds", value: t.seconds },
  ];

  return (
    <section
      data-testid="countdown-section"
      className="py-14 md:py-20 px-6 md:px-12 bg-[#070707] border-t border-white/5"
    >
      <div className="max-w-[1400px] mx-auto">
        <div className="text-center mb-10 reveal">
          <div className="flex items-center justify-center gap-3 mb-4">
            <span className="w-8 h-px bg-gold" />
            <span className="text-xs uppercase tracking-overline text-zinc-500">
              {isLive ? "We're on the road" : "Departure Countdown"}
            </span>
            <span className="w-8 h-px bg-gold" />
          </div>
          <h3 className="font-serif-display text-3xl md:text-5xl tracking-tight leading-[1.05]">
            {isLive ? (
              <>The journey has <em className="italic text-gold">begun</em>.</>
            ) : (
              <>
                The road opens in <em className="italic text-gold">{t.days}</em>{" "}
                days.
              </>
            )}
          </h3>
          <p className="mt-4 text-zinc-500 text-sm">
            June 15, 2026 · 6:00 AM ET
          </p>
        </div>

        <div
          className="grid grid-cols-4 gap-3 md:gap-6 max-w-3xl mx-auto reveal"
          data-testid="countdown-grid"
        >
          {cells.map((c) => (
            <div
              key={c.label}
              data-testid={`countdown-${c.label.toLowerCase()}`}
              className="bg-[#0a0a0a] border border-white/10 px-3 py-6 md:px-6 md:py-8 text-center"
            >
              <div className="font-serif-display text-4xl md:text-6xl tracking-tight text-white tabular-nums">
                {String(c.value).padStart(2, "0")}
              </div>
              <div className="mt-2 text-[10px] md:text-xs uppercase tracking-overline text-gold">
                {c.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
